<template>
  <BFormGroup
    :state="state"
    :invalid-feedback="errorMessage"
    class="mb-3"
  >
    <BFormLabel :required="required" :forId="inputId" :id="labelId" :class="{'fw-bold': required}">
      {{ title }}
    </BFormLabel>
    <BFormInput
      v-model="localValue"
      :state="state"
      :id="inputId"
      :name="inputName"
      maxlength="255"
      :type="type"
      :class="{ 'fw-bold': required, 'mb-1': true }"
      :autocomplete="autocompleteAttr"
      :disabled="disabled"
      :aria-required="required ? 'true' : undefined"
      :aria-invalid="invalid ? 'true' : undefined"
      :aria-labelledby="labelId"
      :aria-describedby="hint ? hintId : null"
      @input="$emit('customInput', localValue)"
    >
    </BFormInput>
    <small v-if="hint" :id="hintId" class="form-text text-muted d-block">
      {{ hint }}
    </small>
  </BFormGroup>
</template>

<script>
import BFormLabel from './BFormLabel.vue'
import { BFormGroup, BFormInput } from 'bootstrap-vue-next'

export default {
  components: {
    BFormGroup, BFormLabel, BFormInput
  },
  data() {
    return {
      localValue: this.value || ''
    }
  },
  watch: {
    value(newVal) {
      this.localValue = newVal || '';
    }
  },
  computed: {
    autocompleteAttr() {
      return this.autocomplete ? "on" : "off";
    },
    state() {
      return this.invalid ? false : null;
    },
    invalid() {
      return !!this.errors.length;
    },
    inputName() {
      return this.disabled ? '' : `${this.modelName}[${this.name}]`;
    },
    inputId() {
      return `${this.modelName}_${this.name}`;
    },
    labelId() {
      return `${this.inputId}_label`;
    },
    hintId() {
      return `${this.inputId}_hint`;
    },
    errorMessage() {
      return this.errors.join(' and ');
    },
    title() {
      return this.label || this.nameHumanized;
    },
    nameHumanized() {
      return this.name.split("_").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
    }
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    errors: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      required: false
    },
    modelName: {
      type: String,
      required: false
    },
    type: {
      type: String,
      default: "text"
    },
    autocomplete: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
